import { Typography } from "@mui/material";
import logo from "../img/image-Photoroom (1).png";
import { useTranslation } from "react-i18next";

export const CorrectiveBill = ({ data, reporteRef, type }) => {
  // Extract date parts
  const date = new Date(data.start_time);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear().toString().slice(-2);

  const { t } = useTranslation();

  // Format times
  const startTime = new Date(data.start_time).toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
  });
  const endTime = new Date(data.end_time).toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
  });

  return (
    <div
      ref={reporteRef}
      style={{
        fontFamily: "Arial, sans-serif",
        fontSize: "10px",
        border: "1px solid black",
        width: "180mm",
        height: "297mm",
        boxSizing: "border-box",
      }}
    >
      {/* encabezado */}
      <div
        style={{
          display: "flex",
          margin: "0 10px",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography
            variant="h6"
            style={{ fontSize: "10px", marginTop: "10px" }}
          >
            F-MTTO {data.id}. {type ?? "REPARACIÓN MANTENIMIENTO"} EQUIPOS
          </Typography>
          <div style={{ marginTop: "30px" }}>
            <h1 style={{ fontSize: "16px", marginBottom: "0" }}>
              REPORTE {type ?? "REPARACIÓN MANTENIMIENTO"} EQUIPOS
            </h1>
            <h2 style={{ fontSize: "16px" }}>
              {type === "PUERTA VEHICULAR"
                ? "PUERTA VEHICULAR"
                : "ASCENSORES - PUERTAS TALANQUERAS Y ACCESOS"}
              .
            </h2>
          </div>
        </div>
        <div style={{ width: "20%", marginTop: "10px" }}>
          <img src={logo} />
        </div>
      </div>

      {/* fechas */}
      <div style={{ display: "flex" }}>
        <div
          style={{
            width: "50%",
            textAlign: "center",
            borderTop: "1px solid black",
            boxSizing: "border-box",
          }}
        >
          <Typography
            variant="h6"
            style={{ fontSize: "16px", margin: "15px 10px" }}
          >
            Fecha Visita:
          </Typography>
        </div>
        <div
          style={{
            width: "50%",
            textAlign: "center",
            borderTop: "1px solid black",
            borderLeft: "1px solid black",
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div style={{ display: "flex" }}>
            <div
              style={{
                borderRigth: "1px solid black",
                borderBottom: "1px solid black",
                boxSizing: "border-box",
                width: "33.3%",
              }}
            >
              <Typography
                variant="h6"
                style={{ fontSize: "16px", margin: "1px 10px" }}
              >
                Dia
              </Typography>
            </div>
            <div
              style={{
                borderRight: "1px solid black",
                borderBottom: "1px solid black",
                borderLeft: "1px solid black",
                boxSizing: "border-box",
                width: "33.3%",
              }}
            >
              <Typography
                variant="h6"
                style={{ fontSize: "16px", margin: "1px 10px" }}
              >
                Mes
              </Typography>
            </div>
            <div
              style={{
                borderBottom: "1px solid black",
                boxSizing: "border-box",
                width: "33.3%",
              }}
            >
              <Typography
                variant="h6"
                style={{ fontSize: "16px", margin: "1px 10px" }}
              >
                Año
              </Typography>
            </div>
          </div>
          <div style={{ display: "flex" }}>
            <div
              style={{
                boxSizing: "border-box",
                width: "33.3%",
              }}
            >
              <Typography
                variant="h6"
                style={{ fontSize: "16px", margin: "1px 10px" }}
              >
                {day}
              </Typography>
            </div>
            <div
              style={{
                borderRight: "1px solid black",
                borderLeft: "1px solid black",
                boxSizing: "border-box",
                width: "33.3%",
              }}
            >
              <Typography
                variant="h6"
                style={{ fontSize: "16px", margin: "1px 10px" }}
              >
                {month}
              </Typography>
            </div>
            <div
              style={{
                boxSizing: "border-box",
                width: "33.3%",
              }}
            >
              <Typography
                variant="h6"
                style={{ fontSize: "16px", margin: "1px 10px" }}
              >
                {year}
              </Typography>
            </div>
          </div>
        </div>
      </div>

      {/* nombres */}
      <div style={{ display: "flex" }}>
        <div
          style={{
            width: "20%",
            textAlign: "center",
            borderTop: "1px solid black",
            boxSizing: "border-box",
          }}
        >
          <Typography
            variant="h6"
            style={{ fontSize: "16px", margin: "15px 0" }}
          >
            Nombre Cliente:
          </Typography>
        </div>
        <div
          style={{
            width: "80%",
            textAlign: "center",
            borderTop: "1px solid black",
            borderLeft: "1px solid black",
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography
            variant="h6"
            style={{ fontSize: "16px", margin: "15px 10px" }}
          >
            {data.client?.name} {data.place}
          </Typography>
        </div>
      </div>

      {/* torres */}
      <div style={{ display: "flex" }}>
        <div
          style={{
            width: "20%",
            textAlign: "center",
            borderTop: "1px solid black",
            boxSizing: "border-box",
          }}
        >
          <Typography
            variant="h6"
            style={{ fontSize: "16px", margin: "15px 0" }}
          >
            Torre:
          </Typography>
        </div>
        <div
          style={{
            width: "20%",
            textAlign: "center",
            borderTop: "1px solid black",
            borderLeft: "1px solid black",
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography
            variant="h6"
            style={{ fontSize: "16px", margin: "15px 10px" }}
          >
            {data.elevator?.building?.name}
          </Typography>
        </div>
        <div
          style={{
            width: "60%",
            textAlign: "center",
            borderTop: "1px solid black",
            borderLeft: "1px solid black",
            boxSizing: "border-box",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <Typography
            variant="h6"
            style={{ fontSize: "16px", margin: "15px 10px" }}
          >
            Equipo: {data.elevator?.identifier}
          </Typography>
          <Typography
            variant="h6"
            style={{ fontSize: "16px", margin: "15px 10px" }}
          >
            Estado: {t(data.status)}
          </Typography>
        </div>
      </div>

      {/* horaIngreso */}
      <div style={{ display: "flex" }}>
        <div
          style={{
            width: "70%",
            textAlign: "center",
            borderTop: "1px solid black",
            boxSizing: "border-box",
          }}
        >
          <Typography
            variant="h6"
            style={{ fontSize: "16px", margin: "15px 0" }}
          >
            Hora Ingreso (24hrs):
          </Typography>
        </div>
        <div
          style={{
            width: "30%",
            textAlign: "center",
            borderTop: "1px solid black",
            borderLeft: "1px solid black",
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography
            variant="h6"
            style={{ fontSize: "16px", margin: "15px 10px" }}
          >
            {startTime}
          </Typography>
        </div>
      </div>

      {/* horaSalida */}
      <div style={{ display: "flex" }}>
        <div
          style={{
            width: "70%",
            textAlign: "center",
            borderTop: "1px solid black",
            boxSizing: "border-box",
          }}
        >
          <Typography
            variant="h6"
            style={{ fontSize: "16px", margin: "15px 0" }}
          >
            Hora Salida (24hrs):
          </Typography>
        </div>
        <div
          style={{
            width: "30%",
            textAlign: "center",
            borderTop: "1px solid black",
            borderLeft: "1px solid black",
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <Typography
            variant="h6"
            style={{ fontSize: "16px", margin: "15px 10px" }}
          >
            {endTime}
          </Typography>
        </div>
      </div>

      {/* descripcion */}
      <div style={{ display: "flex" }}>
        <div
          style={{
            width: "100%",
            textAlign: "center",
            borderTop: "1px solid black",
            boxSizing: "border-box",
          }}
        >
          <Typography
            variant="h6"
            style={{ fontSize: "16px", margin: "15px 0" }}
          >
            Descripción
          </Typography>
        </div>
      </div>
      <div style={{ display: "flex" }}>
        <div
          style={{
            width: "100%",
            textAlign: "center",
            borderTop: "1px solid black",
            boxSizing: "border-box",
            padding: "10px",
          }}
        >
          <Typography
            variant="h6"
            style={{ fontSize: "16px", margin: "15px 0" }}
          >
            {data.description}
          </Typography>
        </div>
      </div>
      <div style={{ display: "flex", marginTop: "20%" }}>
        <div
          style={{
            width: "50%",
            textAlign: "center",
            borderTop: "1px solid black",
            boxSizing: "border-box",
            padding: "10px",
          }}
        >
          <Typography
            variant="h6"
            style={{ fontSize: "16px", margin: "5px 0" }}
          >
            Firma Cliente
          </Typography>
          <div style={{ height: "100px" }}>
            {data.signature_url && (
              <img
                src={data.signature_url}
                alt="Client Signature"
                style={{ maxHeight: "100%", maxWidth: "100%" }}
                crossOrigin="anonymous"
              />
            )}
          </div>
          <Typography
            variant="h6"
            style={{ fontSize: "14px", margin: "5px 0" }}
          >
            Nombre: {data.person_name}
          </Typography>
          <Typography
            variant="h6"
            style={{ fontSize: "14px", margin: "5px 0" }}
          >
            C.C: {data.document}
          </Typography>
        </div>

        <div
          style={{
            width: "50%",
            textAlign: "center",
            borderTop: "1px solid black",
            boxSizing: "border-box",
            padding: "10px",
          }}
        >
          <Typography
            variant="h6"
            style={{ fontSize: "16px", margin: "5px 0" }}
          >
            Firma Técnico
          </Typography>
          <div style={{ height: "100px" }}>
            {data.technicianSignature && (
              <img
                src={data.technicianSignature}
                alt="Client Signature"
                style={{ maxHeight: "100%", maxWidth: "100%" }}
              />
            )}
          </div>
          <Typography
            variant="h6"
            style={{ fontSize: "14px", margin: "5px 0" }}
          >
            Nombre: {data.user?.name}
          </Typography>
          <Typography
            variant="h6"
            style={{ fontSize: "14px", margin: "5px 0" }}
          >
            C.C: {data.user?.document}
          </Typography>
        </div>
      </div>
    </div>
  );
};
